import { createSelector } from 'reselect'
import { flatten } from 'lodash'
import { folderSharing } from '@edulastic/constants'
import { getUserIdSelector, isTestFolderSharingEnabledSelector } from './user'

const { FOLDER_ROLE } = folderSharing

export const stateSelector = (state) => state.folder

export const getFoldersSelector = createSelector(
  stateSelector,
  isTestFolderSharingEnabledSelector,
  getUserIdSelector,
  (state, isSharingEnabled, userId) => {
    const folders = state.entities || []
    if (isSharingEnabled) {
      return folders
    }
    return folders.filter(
      (folder) =>
        String(folder?.owner?._id) === String(userId) ||
        folder?.myRole === FOLDER_ROLE.OWNER
    )
  }
)

export const getFolderSelector = createSelector(
  stateSelector,
  (state) => state.entity || {}
)

export const getSelectedItems = createSelector(
  stateSelector,
  (state) => state.selectedItems || []
)

export const isOpenAddItemsModalSelector = createSelector(
  stateSelector,
  (state) => state.isOpenAddItemModal
)

export const isOpenRemovalModalSelector = createSelector(
  stateSelector,
  (state) => state.isOpenRemovalModal
)

export const getItemsInFolders = createSelector(stateSelector, (state) =>
  flatten(state.entities.map((f) => f.content.map((c) => c._id)))
)

export const getUpdatedFolderSelector = createSelector(
  stateSelector,
  (state) => state.updatedFolder
)

export const isOpenShareModalSelector = createSelector(
  stateSelector,
  (state) => state.isOpenShareModal
)

export const getShareFolderIdSelector = createSelector(
  stateSelector,
  (state) => state.shareFolderId
)

export const getPendingCollaboratorsSelector = createSelector(
  stateSelector,
  (state) => state.pendingCollaborators
)

export const getPendingDistrictViewerSelector = createSelector(
  stateSelector,
  (state) => state.pendingDistrictViewer
)

export const isFolderSharingSelector = createSelector(
  stateSelector,
  (state) => state.sharing
)
